import { ThemeUICSSObject } from 'theme-ui';
import switchMultiple from './switchMultiple';

export const fields: ThemeUICSSObject = {
  switchMultiple,
};
